<template>
  <div id="app" >
    <div v-if="resourceWarning" class="resource-loading-mask">
      <div class="resource-loading-content">
        <span class="resource-loading-spinner"></span>
        <span class="resource-tip">系统分配资源不足，需要排队{{ resourceWarningTimeText }}，请联系SPD运营团队</span>
      </div>
    </div>
 
    <!-- <template v-if="this.isRouterAlive"> -->
      <!-- <keep-alive >
      <router-view v-if="$route.meta.keepAlive || this.isRouterAlive" :key="fullPath" ref="pagemain"></router-view>
    </keep-alive> -->
    <router-view  v-if="this.isRouterAlive" ></router-view>
    <!-- </template> -->
  
  

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// Loading 已在 main.js 中通过 element-ui/lib/loading 注册，此处无需导入
// import $ from 'jquery'
// signalR 和 suspend 已移至 Layout.vue 动态加载，此处删除无用导入（省 ~138KB 初始包体积）

export default {
  name: 'App',

  provide() {
    return {
      clearKeepAlive: this.clearKeepAlive,
      reload:this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      resourceWarning: false,
      resourceWarningTimeText: '05:00',
      resourceWarningTimer: null
    }
  },
  computed: {
    ...mapGetters([
      'oidcIsAuthenticated'
    ]),
    fullPath() {
      // console.log(this.$route.fullPath);
      return this.$route.fullPath;
    },
  },
  created() {
    this.showResourceWarning()
    window.addEventListener('resource-warning', this.showResourceWarning)
  },
  methods: {
   
    appmethod() {

    },
    userLoaded: function (e) {
      console.log('I am listening to the user loaded event in vuex-oidc', e.detail)
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true

      })
    },
    showResourceWarning() {
      const until = Number(window.localStorage.getItem('resourceWarningUntil'))
      if (!until) {
        return
      }

      if (this.resourceWarningTimer) {
        window.clearInterval(this.resourceWarningTimer)
      }

      this.refreshResourceWarning(until)
      this.resourceWarningTimer = window.setInterval(() => {
        this.refreshResourceWarning(until)
      }, 1000)
    },
    refreshResourceWarning(until) {
      const remaining = until - Date.now()
      if (remaining <= 0) {
        window.localStorage.removeItem('resourceWarningUntil')
        this.resourceWarning = false
        this.resourceWarningTimeText = '00:00'
        if (this.resourceWarningTimer) {
          window.clearInterval(this.resourceWarningTimer)
        }
        this.resourceWarningTimer = null
        return
      }

      this.resourceWarning = true
      const totalSeconds = Math.ceil(remaining / 1000)
      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0')
      const seconds = (totalSeconds % 60).toString().padStart(2, '0')
      this.resourceWarningTimeText = `${minutes}:${seconds}`
    }

  },
  mounted() {

    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
  },
  destroyed() {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
    window.removeEventListener('resource-warning', this.showResourceWarning)
    if (this.resourceWarningTimer) {
      window.clearInterval(this.resourceWarningTimer)
    }
  }
}
</script>

<style>
/* ⚠️ 已移除原此处的弹窗层级强制覆盖CSS（.v-modal display:none / .el-dialog__wrapper z-index:100000 / .el-dialog z-index:100001）
   原因：固定z-index会破坏 Element UI PopupManager 的自动递增机制，
         导致多层弹窗（如editVxeTable插入行弹窗）无法正确叠加，弹窗跑到页面底部。
         移除后由 Element UI 自动管理弹窗层级。 */

/* 降低侧边栏、标签等元素的层级，避免遮挡弹窗 */
#app .sidebar-container,
.tagssty .iconl,
.tagssty .iconr,
.el-header[data-v-136492ee] {
  z-index: 1 !important;
}

/* 降低卡片层级 */
.el-card {
  position: relative;
  z-index: 0 !important;
}

/* 降低表格固定列的层级 */
.el-table__fixed,
.el-table__fixed-right {
  z-index: 1 !important;
}

.resource-loading-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.86);
}

.resource-loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 320px;
  min-height: 160px;
  padding: 24px 32px;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.resource-loading-spinner {
  width: 46px;
  height: 46px;
  margin-bottom: 20px;
  border: 5px solid rgba(64, 158, 255, 0.25);
  border-top-color: #409eff;
  border-radius: 50%;
  animation: resource-loading-spin 0.9s linear infinite;
}

@keyframes resource-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
